import { render } from "./ContactsList.vue?vue&type=template&id=75fa255a&scoped=true&ts=true"
import script from "./ContactsList.vue?vue&type=script&lang=ts"
export * from "./ContactsList.vue?vue&type=script&lang=ts"

import "./ContactsList.vue?vue&type=style&index=0&id=75fa255a&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75fa255a"]])

export default __exports__